import { Component, Input } from '@angular/core';
import { BaseComponent } from 'src/app/core/infrastructure/classes/base-component';
import { InventoryStatus } from 'src/app/core/infrastructure/enums/meta-data-field.enum';

@Component({
  selector: 'app-inventory-status-badge',
  templateUrl: './inventory-status-badge.component.html',
  styleUrls: ['./inventory-status-badge.component.scss'],
})
export class InventoryStatusBadgeComponent extends BaseComponent {
  @Input() status: InventoryStatus;

  readonly InventoryStatus = InventoryStatus;
}
